import { c as _c } from "react/compiler-runtime";
import { BottomSheetBody, BottomSheetHeader, BottomSheetHeaderTitle, Flex, FlexColumn, ItemAvatar, ItemContent, ItemSide, Separator, SkeletonBlock, SkeletonLine } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { AcceptOffersSummarySkeleton } from "../../../components/AcceptOffersSummary";
import { ActionTimelineSkeleton } from "../../../components/ActionTimeline/ActionTimelineSkeleton";
import { Item } from "../../../components/Item";
export function AcceptOfferFlowSkeleton(t0) {
  const $ = _c(17);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 1 : t1;
  const t = useTranslations("wallet.AcceptOfferFlow");
  let t2;
  if ($[0] !== t) {
    t2 = t("accept", {
      count: 1
    });
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <BottomSheetHeader><BottomSheetHeaderTitle>{t2}</BottomSheetHeaderTitle></BottomSheetHeader>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== count) {
    t4 = new Array(count).fill(0).map(_temp);
    $[4] = count;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <FlexColumn>{t4}</FlexColumn>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Separator />;
    t7 = <AcceptOffersSummarySkeleton />;
    t8 = <Separator />;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Flex className="w-full py-4"><ActionTimelineSkeleton count={1} /></Flex>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t5) {
    t10 = <BottomSheetBody className="mt-2 pb-2">{t5}{t6}{t7}{t8}{t9}</BottomSheetBody>;
    $[12] = t5;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t3) {
    t11 = <>{t3}{t10}</>;
    $[14] = t10;
    $[15] = t3;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}
function _temp(_, index) {
  return <Item className="py-2.5" key={index} variant="unstyled"><ItemAvatar size={48}><SkeletonBlock className="size-12 rounded" /></ItemAvatar><ItemContent className="gap-2"><SkeletonLine className="h-5 w-24" /><SkeletonLine className="h-5 w-32" /></ItemContent><ItemSide><SkeletonLine className="h-5 w-16" /><SkeletonLine className="h-5 w-12" /></ItemSide></Item>;
}